// colors used on the website (not all used)

const colors = {
  primary: '#669900',
  primaryInverted: '#9966ff',
  secondary: '#000',
  tertiary: '#fff',
  whiteAntique: '#FAEBD7',
  darkBrown: '#666600',
  zircon: '#EDF0F1',
  gray: '#808080',
  warning: '#B00020',
  light: '#f8f9fa',
  lightOpacity: 'rgba(248, 249, 250, 0.95)',

 // night mode colors
  darkNavy: '#020c1b',
  navy: '#0a192f',
  lightNavy: '#112240',
  lightestNavy: '#233554',
  lightestNavyOpacity: 'rgba(35, 53, 84, 0.95)',
  darkSlate: '#495670',
  slate: '#8892b0',
  lightSlate: '#a8b2d1',
  lightestSlate: '#ccd6f6',
  lightGreen: '#64ffda',
  chromeBlue: '#3297FD',

  // toast
  success: '#5cb85c',
  danger: '#d9534f',
  info: '#5bc0de',
  warn: '#f0ad4e',
}

export default colors



